import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HeaderFour from "../../components/Header/HeaderFour";
import Footer from "../../components/Footer";
import Breadcrumb from "../../components/Breadcrumb";
import Seo from "../../components/Seo";
import makeRequest from "../../makeRequest";
import config from "../../config";

const STYLE_ID = "careers-styles";

const injectStyles = () => {
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
    .careers-hero {
      background: linear-gradient(135deg, #0d1f3c 0%, #1a4a7a 60%, #0d9e8a 100%);
      padding: 70px 0 60px;
      color: #fff;
      text-align: center;
    }
    .careers-hero h1 {
      font-size: 3rem;
      font-weight: 800;
      letter-spacing: -0.5px;
      margin-bottom: 14px;
    }
    .careers-hero p {
      font-size: 1.15rem;
      opacity: 0.88;
      max-width: 560px;
      margin: 0 auto 28px;
    }
    .careers-hero-badge {
      display: inline-block;
      background: rgba(255,255,255,0.15);
      border: 1px solid rgba(255,255,255,0.25);
      border-radius: 30px;
      padding: 6px 20px;
      font-size: 0.85rem;
      font-weight: 600;
      letter-spacing: 1px;
      text-transform: uppercase;
      margin-bottom: 18px;
    }
    .careers-section {
      background: #f0f4f8;
      padding: 60px 0 80px;
    }
    .careers-filters {
      display: flex;
      gap: 14px;
      flex-wrap: wrap;
      align-items: center;
      margin-bottom: 40px;
    }
    .careers-search {
      flex: 1;
      min-width: 220px;
      position: relative;
    }
    .careers-search input {
      width: 100%;
      padding: 12px 18px 12px 44px;
      border: 2px solid #e0e7ef;
      border-radius: 50px;
      font-size: 0.95rem;
      background: #fff;
      outline: none;
      transition: border-color 0.2s;
    }
    .careers-search input:focus { border-color: #1a4a7a; }
    .careers-search-icon {
      position: absolute;
      left: 16px;
      top: 50%;
      transform: translateY(-50%);
      color: #8ea3bb;
      font-size: 1rem;
    }
    .careers-filter-btn {
      padding: 11px 20px;
      border-radius: 50px;
      border: 2px solid #e0e7ef;
      background: #fff;
      font-size: 0.9rem;
      font-weight: 600;
      color: #4a6080;
      cursor: pointer;
      transition: all 0.2s;
    }
    .careers-filter-btn.active, .careers-filter-btn:hover {
      background: #1a4a7a;
      border-color: #1a4a7a;
      color: #fff;
    }
    .careers-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
      gap: 28px;
    }
    .career-card {
      background: #fff;
      border-radius: 18px;
      overflow: hidden;
      box-shadow: 0 4px 24px rgba(13,31,60,0.08);
      transition: transform 0.25s ease, box-shadow 0.25s ease;
      display: flex;
      flex-direction: column;
      border: 1px solid rgba(26,74,122,0.08);
    }
    .career-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 12px 40px rgba(13,31,60,0.16);
    }
    .career-card-image {
      width: 100%;
      height: 200px;
      object-fit: cover;
      background: linear-gradient(135deg, #1a4a7a, #0d9e8a);
    }
    .career-card-image-placeholder {
      width: 100%;
      height: 200px;
      background: linear-gradient(135deg, #1a4a7a 0%, #0d9e8a 100%);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .career-card-image-placeholder span {
      font-size: 3.5rem;
      opacity: 0.4;
    }
    .career-card-body {
      padding: 24px;
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .career-card-badges {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
      margin-bottom: 4px;
    }
    .career-badge {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      padding: 4px 12px;
      border-radius: 20px;
      font-size: 0.78rem;
      font-weight: 600;
    }
    .career-badge-type-fulltime { background: #d4edda; color: #1a6630; }
    .career-badge-type-parttime { background: #cce5ff; color: #004085; }
    .career-badge-type-contract { background: #fff3cd; color: #856404; }
    .career-badge-type-internship { background: #e2d9f3; color: #492496; }
    .career-badge-location { background: #f0f4f8; color: #4a6080; }
    .career-badge-deadline { background: #ffe5e5; color: #c0392b; }
    .career-badge-deadline-ok { background: #f0f9f7; color: #0d7a6a; }
    .career-card-title {
      font-size: 1.2rem;
      font-weight: 700;
      color: #1a2e4a;
      line-height: 1.4;
    }
    .career-card-desc {
      font-size: 0.9rem;
      color: #6c757d;
      line-height: 1.6;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .career-card-meta {
      display: flex;
      gap: 14px;
      font-size: 0.82rem;
      color: #7a8da0;
      flex-wrap: wrap;
    }
    .career-card-meta span {
      display: flex;
      align-items: center;
      gap: 5px;
    }
    .career-card-footer {
      padding: 16px 24px 20px;
      display: flex;
      gap: 10px;
      border-top: 1px solid #f0f4f8;
    }
    .career-btn-apply {
      flex: 1;
      background: linear-gradient(135deg, #1a4a7a, #0d9e8a);
      color: #fff;
      border: none;
      border-radius: 50px;
      padding: 11px 0;
      font-size: 0.9rem;
      font-weight: 700;
      text-decoration: none;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      transition: opacity 0.2s;
    }
    .career-btn-apply:hover { opacity: 0.88; color: #fff; text-decoration: none; }
    .career-btn-apply.expired {
      background: #e0e7ef;
      color: #a0afbe;
      pointer-events: none;
    }
    .career-btn-details {
      padding: 11px 20px;
      border: 2px solid #e0e7ef;
      border-radius: 50px;
      font-size: 0.85rem;
      font-weight: 600;
      color: #1a4a7a;
      text-decoration: none;
      transition: all 0.2s;
    }
    .career-btn-details:hover { background: #1a4a7a; color: #fff; border-color: #1a4a7a; text-decoration: none; }
    .careers-empty {
      text-align: center;
      padding: 80px 20px;
      color: #8ea3bb;
    }
    .careers-empty h3 { font-size: 1.4rem; font-weight: 700; margin-bottom: 10px; color: #4a6080; }
    .careers-empty p { font-size: 0.95rem; }
    .careers-loading {
      text-align: center;
      padding: 80px 20px;
      color: #8ea3bb;
    }
    @media (max-width: 768px) {
      .careers-hero h1 { font-size: 2rem; }
      .careers-grid { grid-template-columns: 1fr; }
    }
  `;
  document.head.appendChild(style);
};

const JOB_TYPES = ["All", "Full-time", "Part-time", "Contract", "Internship"];

const typeClass = (t) => {
  const map = {
    "Full-time": "career-badge-type-fulltime",
    "Part-time": "career-badge-type-parttime",
    Contract: "career-badge-type-contract",
    Internship: "career-badge-type-internship",
  };
  return map[t] || "career-badge-location";
};

function DeadlineBadge({ deadline }) {
  if (!deadline) return null;
  const d = new Date(deadline);
  const expired = d < new Date();
  const label = expired ? "Expired" : `Closes ${d.toLocaleDateString("en-PK", { day: "numeric", month: "short", year: "numeric" })}`;
  return <span className={`career-badge ${expired ? "career-badge-deadline" : "career-badge-deadline-ok"}`}>🗓 {label}</span>;
}

function CareerCard({ item }) {
  const [imageSrc, setImageSrc] = useState(null);
  const expired = item.deadline && new Date(item.deadline) < new Date();

  useEffect(() => {
    let objectUrl = null;
    let cancelled = false;
    if (item.hasImage) {
      fetch(`${config.api.baseUrl}/website/career/${item.id}/image`)
        .then((r) => r.blob())
        .then((b) => {
          if (!cancelled) {
            objectUrl = URL.createObjectURL(b);
            setImageSrc(objectUrl);
          }
        })
        .catch(() => {});
    }
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [item.id, item.hasImage]);

  return (
    <div className="career-card">
      {imageSrc ? (
        <img src={imageSrc} alt={item.title || item.name} className="career-card-image" />
      ) : (
        <div className="career-card-image-placeholder">
          <span>🏥</span>
        </div>
      )}
      <div className="career-card-body">
        <div className="career-card-badges">
          {item.jobType && <span className={`career-badge ${typeClass(item.jobType)}`}>{item.jobType}</span>}
          {item.location && <span className="career-badge career-badge-location">📍 {item.location}</span>}
          <DeadlineBadge deadline={item.deadline} />
        </div>
        <div className="career-card-title">{item.title || item.name}</div>
        {item.description && <p className="career-card-desc">{item.description}</p>}
        <div className="career-card-meta">
          {item.experience && <span>⏱ {item.experience}</span>}
          {item.salaryRange && <span>💵 {item.salaryRange}</span>}
        </div>
      </div>
      <div className="career-card-footer">
        <Link to={`/careers/${item.id}`} className={`career-btn-apply ${expired ? "expired" : ""}`}>
          {expired ? "Expired" : "✉ Apply Now"}
        </Link>
        <Link to={`/careers/${item.id}`} className="career-btn-details">
          Details
        </Link>
      </div>
    </div>
  );
}

function Careers() {
  useEffect(() => {
    injectStyles();
  }, []);

  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [filterType, setFilterType] = useState("All");

  useEffect(() => {
    makeRequest({ route: "/website/career/public", method: "get" })
      .then((data) => setJobs(Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : []))
      .catch(() => setJobs([]))
      .finally(() => setLoading(false));
  }, []);

  const filtered = jobs.filter((j) => {
    const matchType = filterType === "All" || j.jobType === filterType;
    const q = search.toLowerCase();
    const matchSearch =
      !q ||
      (j.title || "").toLowerCase().includes(q) ||
      (j.name || "").toLowerCase().includes(q) ||
      (j.location || "").toLowerCase().includes(q);
    return matchType && matchSearch;
  });

  return (
    <>
      <Seo title="Careers | Maroof International Hospital" />
      <HeaderFour />
      <div className="careers-hero">
        <div className="container">
          <span className="careers-hero-badge">Join Our Team</span>
          <h1 style={{ color: "white" }}>Build a Career That Matters</h1>
          <p>Be part of a team dedicated to delivering world-class healthcare. Explore open positions and make a difference every day.</p>
        </div>
      </div>

      <section className="careers-section">
        <div className="container">
          <div className="careers-filters">
            <div className="careers-search">
              <span className="careers-search-icon">🔍</span>
              <input type="text" placeholder="Search jobs by title or location..." value={search} onChange={(e) => setSearch(e.target.value)} />
            </div>
            {JOB_TYPES.map((t) => (
              <button key={t} className={`careers-filter-btn${filterType === t ? " active" : ""}`} onClick={() => setFilterType(t)}>
                {t}
              </button>
            ))}
          </div>

          {loading ? (
            <div className="careers-loading">
              <p>Loading opportunities...</p>
            </div>
          ) : filtered.length === 0 ? (
            <div className="careers-empty">
              <h3>No Positions Found</h3>
              <p>{search || filterType !== "All" ? "Try adjusting your filters." : "No open positions at the moment. Check back soon!"}</p>
            </div>
          ) : (
            <div className="careers-grid">
              {filtered.map((job) => (
                <CareerCard key={job.id} item={job} />
              ))}
            </div>
          )}
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Careers;
